import { useEffect, useRef } from "react";
import { registerPlugin } from '@capacitor/core';

const BackgroundGeolocation = registerPlugin('BackgroundGeolocation');

const GlobalWorkerTracker = () => {
    const watcherIdRef = useRef(null);

    useEffect(() => {
        const handleStorageChange = () => manageTracking();
        window.addEventListener('storage', handleStorageChange);
        manageTracking();

        const backupInterval = setInterval(manageTracking, 60000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            clearInterval(backupInterval);
            stopTracking();
        };
    }, []);

    const manageTracking = async () => {
        const workerId = localStorage.getItem("workerId");
        const mode = localStorage.getItem("mode");

        if (workerId && mode === "work") {
            if (!watcherIdRef.current) {
                console.log("🟢 Pradedamas sekimas darbuotojui:", workerId);
                await startTracking(workerId);
            }
        } else if (watcherIdRef.current) {
            console.log("🔴 Stabdomas sekimas...");
            await stopTracking();
        }
    };

    const startTracking = async (passedWorkerId) => {
        try {
            // Saugiklis: Jei jau veikia - išvalom seną
            await BackgroundGeolocation.removeWatcher({ id: 'active_tracking' }).catch(() => {});

            const id = await BackgroundGeolocation.addWatcher(
                {
                    backgroundMessage: "Jūsų vieta siunčiama administratoriui.",
                    backgroundTitle: "Darbas Vyksta",
                    requestPermissions: true,
                    stale: false,
                    distanceFilter: 5,   
                    interval: 30000,     
                    accuracy: "high",
                    enableHighAccuracy: true,
                    foregroundService: true,
                },
                async (location, error) => {
                    if (error) {
                        console.error("❌ GPS Klaida:", error);
                        return;
                    }

                    // --- NAUJAS FILTRAS: VORATINKLIO NAIKINIMAS ---
                    // Tikriname tikslumą. Jei paklaida > 30m (pvz. tarp pastatų), nesiunčiam.
                    const accuracy = location?.accuracy || location?.coords?.accuracy;
                    
                    if (accuracy && accuracy > 30) {
                        // Nieko nedarom, tiesiog return. Tai neleis nupiešti "nesąmonių".
                        return; 
                    }
                    // ------------------------------------------------

                    // --- DUOMENŲ PARUOŠIMAS ---
                    const currentWorkerId = localStorage.getItem("workerId") || passedWorkerId;
                    const adminId = localStorage.getItem("adminId");

                    if (!currentWorkerId) return;

                    const lat = location?.latitude || location?.coords?.latitude;
                    const lng = location?.longitude || location?.coords?.longitude;
                    const speed = location?.speed || location?.coords?.speed || 0;

                    const dataToSend = {
                        workerId: String(currentWorkerId),
                        adminId: adminId ? String(adminId) : "",
                        status: "active_native",
                        timestamp: new Date().toISOString(),
                        lat: lat ? parseFloat(lat) : null,
                        lng: lng ? parseFloat(lng) : null,
                        speed: parseFloat(speed)
                    };

                    console.log("📤 Siunčiamas GPS paketas:", JSON.stringify(dataToSend));

                    // --- SIUNTIMAS (FIX'AS ANDROID FONO REŽIMUI) ---
                    try {
                        await fetch("https://updatelocation-q3t6k7n7ja-uc.a.run.app", {
                            method: "POST",
                            mode: "cors",           
                            cache: "no-cache",
                            keepalive: true,        // SVARBIAUSIA: Neleidžia Androidui numesti Body fone
                            headers: { 
                                "Content-Type": "application/json",
                                "Accept": "application/json" 
                            },
                            body: JSON.stringify(dataToSend)
                        });
                    } catch (err) {
                        console.error("❌ Tinklo klaida siunčiant iš fono:", err);
                    }
                }
            );
            
            watcherIdRef.current = id;
        } catch (e) {
            console.error("❌ Nepavyko paleisti GPS:", e);
        }
    };

    const stopTracking = async () => {
        if (watcherIdRef.current) {
            await BackgroundGeolocation.removeWatcher({ id: watcherIdRef.current }).catch(() => {});
            watcherIdRef.current = null;
        }
    };

    return null;
};

export default GlobalWorkerTracker;